import { render, staticRenderFns } from "./Plantao.vue?vue&type=template&id=9d6c63c0"
import script from "./Plantao.vue?vue&type=script&lang=js"
export * from "./Plantao.vue?vue&type=script&lang=js"
import style0 from "./Plantao.vue?vue&type=style&index=0&id=9d6c63c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports